module.exports = __webpack_public_path__ + "static/img/studio-logo.1821de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/studio-logo.png
// module id = O4VL
// module chunks = 46